import axios from "axios";
import host from "../../../../global";

// The candidate proves identity once via OTP (ScheduleTest.jsx), which returns
// a token scoped to that one interview_id — stored here, attached to every
// call below. Backend rejects anything missing it, or scoped to a different
// interview_id, with 401/403.
const candidateAuthHeader = (interviewId) => {
  const token = sessionStorage.getItem(`candidateToken_${interviewId}`);
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getConfigurations = (interviewId) =>
  axios.get(`${host}/get_configurations_wo_auth/${interviewId}`);

export const proceedToNextQuestion = (interviewId) =>
  axios.post(`${host}/proceed_to_next_question/${interviewId}`, {}, {
    headers: candidateAuthHeader(interviewId),
  });

export const uploadAnswer = (interviewId, formData) =>
  axios.post(`${host}/getquestion/${interviewId}`, formData, {
    headers: { "Content-Type": "multipart/form-data", ...candidateAuthHeader(interviewId) },
  });

export const checkInterviewState = (interviewId) =>
  axios.get(`${host}/check_interview_state/${interviewId}`, {
    headers: candidateAuthHeader(interviewId),
  });

export const resumeInterviewReq = (interviewId) =>
  axios.post(`${host}/resumeinterview/${interviewId}`, {}, {
    headers: candidateAuthHeader(interviewId),
  });

export const deleteInterviewFiles = (interviewId, endTimeISO, payload) =>
  axios.delete(`${host}/delete-interview-files/${interviewId}`, {
    params: {
      end_time: endTimeISO,
    },
    data: payload,
    headers: candidateAuthHeader(interviewId),
  });

export const proceedToNextQuestionPost = (interviewId) =>
  axios.post(`${host}/proceed_to_next_question/${interviewId}`, {}, {
    headers: candidateAuthHeader(interviewId),
  });

export const uploadCandidateSnapshot = (interviewId, formData) =>
  axios.post(`${host}/upload_candidate_snapshot/${interviewId}`, formData, {
    headers: { "Content-Type": "multipart/form-data", ...candidateAuthHeader(interviewId) },
  });

export const generateUploadUrls = (interviewId, questionIndex, hasVideo) =>
  axios.post(`${host}/generate_upload_urls/${interviewId}`,
    new URLSearchParams({
      question_index: questionIndex,
      has_video: hasVideo
    }),
    {
      headers: { "Content-Type": "application/x-www-form-urlencoded", ...candidateAuthHeader(interviewId) },
    }
  );

// Goes straight to a presigned S3 URL, not our backend — must NOT carry the
// candidate token (S3 doesn't expect it, and the presigned URL is already
// its own proof of authorization for that one upload).
export const uploadToS3 = async (presignedUrl, blob, contentType) => {
  return axios.put(presignedUrl, blob, {
    headers: {
      'Content-Type': contentType,
    },
  });
};

export const submitAnswerWithS3Keys = (interviewId, audioKey, videoKey, alerts , candidateAnsText) =>
  axios.post(`${host}/getquestion/${interviewId}`,
    new URLSearchParams({
      audio_s3_key: audioKey,
      video_s3_key: videoKey || '',
      face_alert_required: alerts.face || 'false',
      multiple_face_alert_required: alerts.multipleFace || 'false',
      prohibited_object_alert_required: alerts.prohibitedObject || 'false',
      body_posture_alert_required: alerts.bodyPosture || 'false',
      gaze_alert_required: alerts.gaze || 'false',
      body_posture_modal: alerts.bodyPostureModal || 'false',
      gaze_modal: alerts.gazeModal || 'false',
      candidate_answer_text: candidateAnsText || ''
    }),
    {
      headers: { "Content-Type": "application/x-www-form-urlencoded", ...candidateAuthHeader(interviewId) },
    }
  );
